.icons {
  width: 23px;
}

.icons svg {
  fill: currentColor;
  margin: 0px 2px;
  width: 1.4em;
  padding-top: 3px;
}

.icons .valid svg {
  fill: green;
}

.icons .warning svg {
  fill: #c7c739;
}

.icons .invalid svg {
  fill: red;
}

.inline {
  display: flex;
  align-items: center;
}

.birthdate input {
  border-right: 1px solid var(--field-border);
}
